import React from "react";
import { Navigate, useParams } from "react-router-dom";
import EducationVideoPlayer from "@/components/EducationVideo/EducationVideoPlayer";
import { isEducationVideoId } from "@/components/EducationVideo/educationVideos";

const EducationVideoPage: React.FC = () => {
  const { videoId } = useParams();
  if (!isEducationVideoId(videoId)) {
    return <Navigate to="/" replace />;
  }
  return <EducationVideoPlayer videoId={videoId} />;
};

export default EducationVideoPage;
